import { useMemo } from "react";
import { TenantStatus } from "../tenant.types";
import { dateHelpers, enumHelpers } from "../../../app/helpers";
import Dropdown from "../../../components/Dropdown";
import { FromControlProps } from "../../../app/types";
import { Badge } from "reactstrap";

export default function TenantStateSelect({ value, onChange, className, disabled }: FromControlProps<TenantStatus>) {
    const items = useMemo(() => {
        var types = enumHelpers.createListItemsFromEnum(TenantStatus);
        return types;
    }, []);

    return (
        <Dropdown
            items={items}
            className={className}
            onChange={(val) => onChange(val ? (+val as TenantStatus) : undefined)}
            value={value?.toString()}
            disabled={disabled}
            showEmptyRow={false}
        />
    );
}

export function TenantStateBadge({ state, eventDate }: { state: TenantStatus; eventDate?: string }) {
    const color = useMemo(() => {
        switch (state) {
            case TenantStatus.Active:
                return "success";
            case TenantStatus.Billing_Lapsed:
                return "warning";
            case TenantStatus.Free_Trial:
                return "primary";
            case TenantStatus.Free_Plan:
                return "info";
            case TenantStatus.Suspended:
                return "danger";
            case TenantStatus.Inactive:
                return "secondary";
        }
    }, [state]);

    const tooltip = useMemo(() => {
        if (!eventDate) return undefined;

        switch (state) {
            case TenantStatus.Billing_Lapsed:
                return `Suspend after: ${dateHelpers.toDateString(eventDate)}`;
            case TenantStatus.Free_Trial:
                return `Free trial ends on: ${dateHelpers.toDateString(eventDate)}`;
        }
    }, [state, eventDate]);

    return (
        <Badge color={color} title={tooltip} className="ms-1 me-1">
            {TenantStatus[state].replace(/_/g, " ")}
        </Badge>
    );
}
